import { gql } from "@urql/core";

// FRAGMENTS

// const projAtrr = gql`
//     pages
//     projectsCount
//     statistics {
//       statuses
//       shared
//       notShared
//     }
//     overallStatistics {
//       statuses
//       shared
//       notShared
//     }
//     filters {
//       searchQuery
//       statuses
//       sharedStatusSwitcher
//     }
// `;

const ProjectListFrag = gql`
  fragment projectListAttrs on ProjectList {
    limit
    page
    pages
    projectsCount
    statistics {
      statuses
      shared
      notShared
    }
    overallStatistics {
      statuses
      shared
      notShared
    }
    filters {
      searchQuery
      statuses
      sharedStatusSwitcher
    }
    items {
      title
      id
      status {
        status
        color
      }
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      sharedWith {
        id
      }
      lastEditBy {
        fullName
      }
    }
  }
`;

const ProjectStatusesFrag = gql`
  fragment projectStatusesAttrs on ProjectStatus {
    status
    color
  }
`;

const ProjectListAttrsFrag = gql`
  fragment projectListAttrs on ProjectList {
    limit
    page
    pages
    projectsCount
    statistics {
      statuses
      shared
      notShared
    }
    overallStatistics {
      statuses
      shared
      notShared
    }
    filters {
      searchQuery
      statuses
      sharedStatusSwitcher
    }
    items {
      title
      id
      status {
        status
        color
      }
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      sharedWith {
        id
      }
      lastEditBy {
        fullName
      }
    }
  }
`;

// QUERIES

const ProjectTreeQry = `
  query project($input:GetProjectInput!) {
    project(input: $input) {
      id
      title
      projectNodes{
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
        active
        accessoryId
        accessoryGroupId
        selectedAccessories {
            seriesId
            pimId
            seriesName
            currentPresentation
            accessoryId
            accessoryGroupId
            infoText
            ordercode {
                parts {
                    options {
                        signatures {
                            description
                            value
                            range
                            isDefault
                            state
                            key
                            title
                            presentation
                        }
                        currentSignature {
                            description
                            value
                            range
                            isDefault
                            state
                            key
                            title
                            presentation
                        }
                        state
                        range {
                            min
                            max
                        }
                        type
                        separator
                        key
                        title
                        presentation
                    }
                    state
                    key
                    title
                    presentation
                }
                key
                title
                presentation
            }
            optionStates {
                partKey
                optionKey
                signatureKey
                parentRef {
                    partKey
                    optionKey
                }
                isSizePart
                signatureValue
                signaturePresentation
                separator
            }
            lastChange {
                partKey
                optionKey
                signatureKey
                parentRef {
                    partKey
                    optionKey
                }
                isSizePart
                signatureValue
                separator
            }
        }
        }
      unit {
        unit
        color
      }
      mandator
    }
  }
`;

const ProjectStatusesQry = gql`
  query currentUser {
    currentUser {
      id
    }
    projectStatuses {
      ...projectStatusesAttrs
    }
  }
  ${ProjectStatusesFrag}
`;

const ProjectListQry = gql`
  query currentUser(
    $limit: Int!
    $page: Int!
    $order: String
    $filters: ProjectListFilterInput
  ) {
    currentUser {
      id
      projectList(
        limit: $limit
        page: $page
        order: $order
        filters: $filters
      ) {
        ...projectListAttrs
      }
    }
  }
  ${ProjectListAttrsFrag}
`;

const ProjectListAndStatusesQry = gql`
  query projectStatuses(
    $limit: Int!
    $page: Int!
    $order: String
    $filters: ProjectListFilterInput
  ) {
    projectStatuses {
      ...projectStatusesAttrs
    }
    currentUser {
      id

      projectList(
        limit: $limit
        page: $page
        order: $order
        filters: $filters
      ) {
        ...projectListAttrs
      }
    }
  }
  ${ProjectListFrag}
  ${ProjectStatusesFrag}
`;

const ProjectDataQry = gql`
  query project($input: GetProjectInput!) {
    project(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version

      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        fullName
      }
    }
  }
`;

// _________Removed pages from field,projectsCount, remebr to add when it is ready _______

const ProjectListTitlesAndIds = gql`
  query currentUser(
    $limit: Int!
    $page: Int!
    $filters: ProjectListFilterInput
  ) {
    currentUser {
      id
      projectList(limit: $limit, page: $page, filters: $filters) {
        limit
        page

        items {
          title
          id
          country
          mandator
        }
      }
    }
  }
`;

const ProjectCommissioningCalcQry = gql`
  query commissioningCalculation($input: CommissioningCalculationInput!) {
    commissioningCalculation(input: $input) {
      data {
        id
        progress
        price
        currency
      }
    }
  }
`;

const CountryListQry = gql`
  query countryList($input: CountryListInput!) {
    countryList(input: $input) {
      items {
        isoTwoLetterCode
        englishName
        displayName
      }
    }
  }
`;

const GetReportQry = gql`
  query reportArchive($input: GetReportArchiveInput!) {
    reportArchive(input: $input) {
      status
      url
    }
  }
`;

export {
  ProjectTreeQry,
  ProjectStatusesQry,
  ProjectListQry,
  ProjectListAndStatusesQry,
  ProjectDataQry,
  ProjectListTitlesAndIds,
  ProjectCommissioningCalcQry,
  CountryListQry,
  GetReportQry,
};
